import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showConsultNowSettingModal } from '../../../../actions/modal';
import { saveConsultNowSettings } from '../../../../actions/waitingArea';

const RightPanelUpdate = ({ currentCheckboxValue, updateOrView, waitingArea }) => {
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const updateConsultNowSettings = () => {
    setIsUpdating(true);
    dispatch(
      saveConsultNowSettings(waitingArea.id, {
        isEnabled: currentCheckboxValue,
      })
    )
      .then((res) => {
        setIsUpdating(false);
        dispatch(showConsultNowSettingModal(false));
      })
      .catch((err) => {
        setIsUpdating(false);
      });
  };
  const saveModalChange = (event) => {
    if (!window.$(event.target).hasClass('disable')) {
      updateConsultNowSettings();
    }
  };

  const closeModal = () => {
    dispatch(showConsultNowSettingModal(false));
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
  return (
    <div>
      {updateOrView == 'update' ? (
        <div className="mrtxxs mrbl max-width">
          <button
            tabIndex="4"
            type="button"
            onClick={saveModalChange}
            data-group="ConsultNowSettings"
            className={isUpdating ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="mrbl max-width mrtxxs ">
          <button
            onClick={closeModal}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
    </div>
  );
};

export default RightPanelUpdate;
